<template>
  <div class="myths-page">
    <div class="uk-section">
      <div class="uk-container uk-container-large">
        <h2 class="myths-page__title">{{ $t(`message['Myths']`) }}</h2>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Myths",
};
</script>
<style lang="css">
.myths-page {
  height: 100vh;
}

.myths-page__title {
  font-size: 50px;
  text-transform: uppercase;
  font-weight: bold;
  color: black;
}
</style>
